import { Injectable } from '@angular/core';
import { SvcServices } from '../services/svc.service';
import { windowService } from '../services/window.service';
import { CommonEventsConfig, FormSubmissionConfigs, PageLoadConfig, ViewDisplayedConfig, AdobePageData } from '../models';



@Injectable({
    providedIn: 'root'
  })
export class AdobeTriggerService{

    private window: any;
    private svcService: any;
    private s: any;
    private _dl = {
      action_type: "",
      layout: "",
      action_subject: "",
      page_details: "",
      area: "",
      view: "",
      module: "",
      pid: "",
      cops: "",
      cyota_id: "",
      fdr_id: "",
      site_events: "",
      navigation_click: "",
      marketing_banner:"",
      marketing_modules: "",
      loaded_modules: "",
      site_section1: "",
      page_inter: "",
      product_identifier:"",
      card_type: "",
      flowSource: "",
      cust_error: "",
    };
    eventsConfig: any = CommonEventsConfig;
    formSubmissionEvents: any = FormSubmissionConfigs;
    pageLoadEvents: any = PageLoadConfig;
    viewDisplayedEvents: any = ViewDisplayedConfig;
    detailedPageName: string;
    pageName: string;


    constructor(private _window: windowService,
      private _svcService: SvcServices) {
        this.window = _window.nativeWindow;
        this.svcService = _svcService;
        this.s = _window.nativeWindow.s;
  }

  public invokeEventSpecificCalls(eventType: any, eventObject: any){
    if(eventType && eventType !== undefined){
      switch(eventType){
        case 'fusionCustomMinorInteraction':
          this.triggerCustomMinorInteraction(eventObject);
          break;
        case 'fusionCustomFormInteraction':
          this.triggerFormInteraction(eventObject);
          break;
        case 'fusionFormInteraction':
          this.triggerFormInteraction(eventObject);
          break;
        case 'fusionCustomFormSubmission':
            this.triggerFormSubmission(eventObject);
        break;
        case 'fusionLinkClick':
          this.triggerLinkClick(eventObject);
          break;
        case 'fusionDmarAdInteraction':
          this.triggerDmarAdInteraction(eventObject);
          break;
        case 'fusionSpeedbumpContinue':
          this.triggerSpeedBumpContinued(eventObject);
          break;
        case 'fusionSpeedbumpCancel':
          this.triggerSpeedBumpCanceled(eventObject);
          break;
        case 'fusionSpeedbumpDisplay':
          this.triggerSpeedBumpDisplayed(eventObject);
          break;
        case 'fusionCustomError':
          this.triggerCustomError(eventObject);
          break;
        case 'fusionCustomPageView':
          this.triggerCustomPageView(eventObject);
          break;
      }
    }
  }

  private populateCommonVariables() {
    this._dl = this.window._dl || {};
    this._dl = {
      action_type: "",
      layout: "",
      action_subject: "",
      page_details: "",
      area: "",
      view: "",
      module: "",
      pid: "",
      cops: "",
      cyota_id: "",
      fdr_id: "",
      site_events: "",
      navigation_click: "",
      marketing_banner:"",
      marketing_modules: "",
      loaded_modules: "",
      site_section1: "",
      page_inter: "",
      product_identifier: "",
      card_type: "",
      flowSource: "",
      cust_error: "",
    };
    return this._dl;
  }

  private clearVariables() {
    this._dl = this.window._dl || {};
  }
  private CommonVariables() {
    this.window._dl.pid = "Anonymous";
    this.window._dl.cyota_id= "Anonymous";
    this.window._dl.fdr_id= "unavailable";
    this.window._dl.cops = "N";
    this.window._dl.layout = "unauthenticated_process";
  }

  private pageLoadFired: boolean = false;

  public triggerPageLoad(elementRef: any){
    if (this.pageLoadFired) {
     console.log("Page load already fired, suppressing duplicate call");
     return;
   }
    this.pageLoadFired = true;
   this.window._dl.cust_error = "";
   this.pageName = sessionStorage.getItem("isSingleSignon") === "true" ? "single_sign_on" : "sign_on";
   this.window._dl.view = "index";
   this.window._dl.module = this.window._dl.page_name;
   this.CommonVariables();
   if(this.window?.dataLayer?.dmarLoadedList){
    this.window._dl.site_events = "event7,event90";
  }else{
    this.window._dl.site_events = "event7";
  }

  this.window._dl.page_details = this.window._dl.page_name;
  this.window._dl.flowSource = this.window._dl.flowSource;

   //PCR013 -Start
   const siteId = this.window._dl.site_id
   const partnerId = siteId.includes("_") ? siteId.split("_")[1] : siteId;
   if(this.window._dl.test_id === "GNADT-7696") {
    this.window._dl.action_type = "page view";
    this.window._dl.page_name = `manage your account on citi thank you overlay ${partnerId}`;
    this.window._dl.page_details = `manage your account on citi thank you overlay ${partnerId}`;
    delete this.window._dl.loaded_modules;
    delete this.window._dl.action_subject;
    delete this.window._dl.area;
    delete this.window._dl.card_type;
    delete this.window._dl.marketing_banner;
    delete this.window._dl.marketing_modules;
    delete this.window._dl.navigation_click;
    delete this.window._dl.partnerBadge;
    delete this.window._dl.product_identifier;
    delete this.window._dl.site_section1;
    delete this.window._dl.view;
   } else {
    this.window._dl.action_type = "lazy page view";
    this.window._dl.loaded_modules = this.populateList1();
    this.window._dl.site_section1 =  this.populateData(elementRef, "module");
    this.window._dl.marketing_modules = this.window.dataLayer.dmarLoadedList;
   }
   //PCR013 -End
   console.log(this.window._dl)
   this.triggerMajorInteractionSCCall(null);
  }

  public triggerLinkClick(elementRef: any){
  // this.populateCommonVariables();
   this.window._dl.cust_error = "";
   this.window._dl.action_type = "event";
   this.window._dl.view = elementRef.view != null ? elementRef.view : this.populateData(elementRef, "view");
   this.window._dl.module = elementRef.module != null ? elementRef.module : this.populateModule(elementRef);
   this.window._dl.area  = elementRef.area != null ? elementRef.area : this.populateArea(elementRef);
   this.window._dl.marketing_modules = "";
   this.CommonVariables();
   this.window._dl.site_section1 = elementRef.site_section1 != null ? elementRef.site_section1 : this.window._dl.page_name;

   // this.window._dl.site_events = this.pageLoadEvents.pageLoad;
    this.window._dl.site_events = "event9";
    let scName = this.populateScName(elementRef);
    let interactName = scName ? scName : null;
    var linkText = elementRef.innerText;
    if(interactName === "forgot_user_id_or_password"){
      this.window._dl.loaded_modules = "";
      this.window._dl.site_section1 = this.window._dl.page_name;
      this.window._dl.product_identifier="fuip";
      this.window._dl.navigation_click = this.window._dl.page_name + " > " + interactName  +  " > "+ interactName  +  " > " + "Forgot User ID or Password";
      this.window._dl.action_subject = "minor_interaction" + ":" + "link_click";
      this.window._dl.page_inter = "Forgot User ID or Password" + " clicked";
      this.window._dl.page_details = this.window._dl.page_name + ":" + this.window._dl.area + ":" + interactName + ":" + interactName +":" + "minor_interaction:link_click";
    } else if(elementRef.scname != null) {
      this.window._dl.loaded_modules = "";
      this.window._dl.page_name = elementRef.page_name;
      this.window._dl.site_section1 = elementRef.site_section1;
      this.window._dl.navigation_click =  elementRef.navigation_click;
      this.window._dl.action_subject = "minor_interaction" + ":" + "link_click";
      this.window._dl.page_inter = elementRef.page_inter;
      this.window._dl.page_details = elementRef.page_details;
    }
     else {
      let display_view;
      if( this.window._dl.area === "header_modules"){
        display_view = "navigation";
      } else {
        display_view = "index";
      }
       this.window._dl.site_section1 =this.populateModule(elementRef);
       //this.window._dl.page_name = "sign_on";
       this.window._dl.navigation_click = this.window._dl.page_name + " > " + this.window._dl.site_section1  + " > " + display_view + " > " + linkText;
      this.window._dl.action_subject = "minor_interaction" + ":" + "link_click";
      if(this.window._dl.module  === "contact_us"){
        this.window._dl.page_inter = "phone: "+linkText + " clicked";
      } else{
          this.window._dl.page_inter = linkText + " clicked";
        }
        this.window._dl.loaded_modules = "";
        this.window._dl.page_details = this.window._dl.page_name + ":" + this.window._dl.area + ":" + this.window._dl.module + ":" + display_view + ":" + "minor_interaction:link_click";
     }
    const isSignonRecoveryLink = !!(elementRef?.classList?.contains("signon_error_retrievelink")  || elementRef?.classList?.contains("signon_error_resetlink"));
    if (isSignonRecoveryLink) {
      this.window._dl.test_id = "GNADT-7968";
    }
     this.triggerMinorInteractionSCCall();
  }

  public triggerFormInteraction(elementRef: any){
    this.window._dl.cust_error = "";
    if(elementRef && elementRef instanceof HTMLElement && elementRef.localName === 'select'){
      return;
    }
    this.window._dl.action_type = "event";
    this.window._dl.site_section1 = elementRef.site_section1 != null ? elementRef.site_section1 : (sessionStorage?.getItem("isSingleSignon") === "true" ? "single_sign_on" : this.populateModule(elementRef));
    this.window._dl.site_events = "event9";
    this.window._dl.view =  elementRef.view != null ? elementRef.view : this.populateModule(elementRef);
    this.window._dl.module =  elementRef.module != null ? elementRef.module : this.populateModule(elementRef);
    this.window._dl.area  = elementRef.area != null ? elementRef.area : this.populateArea(elementRef);
    this.CommonVariables();
    if(elementRef.scname != null){
      this.window._dl.action_subject = "form_interaction:sign_on:footerSec"
      this.window._dl.page_details = "sign_on:footer_modules:contact_us:index:form_interaction:signon:footerSec";
      this.window._dl.page_inter = "contact " + elementRef.target_value+ " clicked";
    }
    else{
      let inputName = this.populateInputName(elementRef);
      this.window._dl.action_subject = "form_interaction:" + this.window._dl.page_name + ":" + inputName;
      this.window._dl.page_details = this.window._dl.page_name + ":" + this.window._dl.area + ":" + this.window._dl.module + ":" + "index" + ":" + "form_interaction:" + this.window._dl.page_name + ":" +inputName;
      if(inputName === "canadaCookieConsent"){
        this.window._dl.page_inter = inputName + " field checked";
      }else{
        this.window._dl.page_inter = "left " + inputName + " field";
      }

    }
    if(elementRef.id != 'rememberMe'){
      this.triggerMinorInteractionSCCall();
    }
  }

  public triggerFormSubmission(eventObject: any){
    this.window._dl.cust_error = "";
    this.window._dl.action_type = "event";
    this.window._dl.site_section1 = sessionStorage?.getItem("isSingleSignon") === "true" ? "single_sign_on" : "sign_on";
    this.window._dl.site_events = eventObject.site_events;
    this.window._dl.test_id = eventObject.test_id;
    this.window._dl.view = eventObject.view;
    this.window._dl.module = eventObject.module;
    this.window._dl.area  = eventObject.area;

    this.CommonVariables();
    this.window._dl.action_subject = eventObject.action_subject;
    this.window._dl.page_details = eventObject.page_details;
    this.window._dl.page_inter = eventObject.page_inter;
    this.triggerMinorInteractionSCCall();
  }

  public triggerCustomMinorInteraction(eventObject: any) {
    this.window._dl.cust_error = "";
    if (eventObject?.page_name) {
      this.window._dl.page_name = eventObject.page_name;
    }
    if (eventObject?.test_id) {
      this.window._dl.test_id = eventObject.test_id;
    }
    this.window._dl.action_type = eventObject.action_type || "event";
    this.window._dl.view = eventObject.view;
    this.window._dl.module = eventObject.module;
    this.window._dl.area  = eventObject.area;
    this.CommonVariables();
    this.window._dl.action_subject = eventObject.action_subject;
    this.window._dl.page_inter = eventObject.page_inter;
    this.window._dl.site_events = eventObject.site_events;
    this.window._dl.site_section1 = eventObject.site_section1;
    this.window._dl.page_details = eventObject.page_details;
    this.window._dl.navigation_click = eventObject.navigation_click != null ? eventObject.navigation_click : "";
   this.triggerMinorInteractionSCCall();
  }

  public triggerServerSideError(text: any) {
    //  this.populateCommonVariables();
     // this.triggerMinorInteractionSCCall(null);
    }

    private triggerSpeedBumpDisplayed(elementRef: any){
    //  this.populateCommonVariables();
        this.window._dl.cust_error = "";
        this.window._dl.action_type = "page view";
        this.window._dl.layout = "unauthenticated_process";
        // this.window._dl.site_events = this.pageLoadEvents.pageLoad;
        this.window._dl.site_events = "event7";
        this.window._dl.view = this.populateData(elementRef, "view");
        this.window._dl.action_subject = "";
        this.window._dl.module = "";
        this.window._dl.area = "";
        this.window._dl.site_section1 = "";
        this.window._dl.loaded_modules = "";
        this.window._dl.navigation_click = "";
        this.window._dl.page_inter = "";
        this.window._dl.marketing_banner = "";
        this.window._dl.marketing_modules = "";
        this.window._dl.page_name = "exit speedbump "+ this.window._dl.site_id
        this.CommonVariables();
        let formId = this.populateformId(elementRef);
        let inputName = this.populateInputName(elementRef);
        let scName = this.populateScName(elementRef); // get dropdown and other customed input sc name
        this.window._dl.page_details = "sign_on";
        this.triggerMajorInteractionSCCall(null);
    }

    private triggerSpeedBumpContinued(eventObject: any){
      this.window._dl.cust_error = "";
      this.window._dl.action_type = "event";
      this.window._dl.site_section1 = "sign_on";
      this.window._dl.page_details = "sign_on";
      this.populateCommonVariables();
      this.CommonVariables();
      this.window._dl.site_events = "event9, event68";
      const siteId = this.window._dl.site_id
      const partnerId = siteId.includes("_") ? siteId.split("_")[1] : siteId;
      //PCR013 -Start
      if(this.window._dl.test_id === "GNADT-7696") {
        this.window._dl.page_name = `manage your account on citi thank you overlay ${partnerId}`;
        if(this.window._dl.button_id_type == "PLCN_CTY") {
          this.window._dl.site_events = "event9";
          this.window._dl.page_inter = "Manage my Citi ThankYou Mastercard";
          this.window._dl.action_subject = "minor_interaction:manage my citi thankyou mastercard";
        } else if(this.window._dl.button_id_type == "PLCN_SYW") {
          this.window._dl.site_events = "event9";
          this.window._dl.page_inter = "Manage my Sears Card, Sears Charge PLUS Card, or Sears Home Improvement Account(SM) clicked";
          this.window._dl.action_subject = "minor_interaction:manage my sears card, sears charge plus card, or sears home improvement account(sm)";
        }
        this.window._dl.page_details = this.window._dl.page_name + ":main:" + this.window._dl.module + ":" + "index" + ":" + this.window._dl.action_subject;
        delete this.window._dl.loaded_modules;
        //delete this.window._dl.action_subject;
        delete this.window._dl.area;
        delete this.window._dl.card_type;
        delete this.window._dl.marketing_banner;
        delete this.window._dl.marketing_modules;
        delete this.window._dl.module;
        delete this.window._dl.navigation_click;
        delete this.window._dl.partnerBadge;
        delete this.window._dl.product_identifier;
        delete this.window._dl.view;
      } else {
        this.window._dl.page_inter = "CONTINUE";
        this.window._dl.action_subject = "minor_interaction:continue";
        this.window._dl.page_name = `exit speedbump ${partnerId}`;
      }
      //PCR013 -End
      this.triggerMinorInteractionSCCall();
    }

    private triggerSpeedBumpCanceled(elementRef: any){
      this.window._dl.cust_error = "";
      this.window._dl.action_type = "event";
      this.window._dl.site_section1 = "sign_on";
      this.window._dl.page_details = "sign_on";
      this.populateCommonVariables();
      this.CommonVariables();
      this.window._dl.site_events = "event9";
      const siteId = this.window._dl.site_id
      const partnerId = siteId.includes("_") ? siteId.split("_")[1] : siteId;
      //PCR013 -Start
      if(this.window._dl.test_id === "GNADT-7696") {
        this.window._dl.page_name = `manage your account on citi thank you overlay ${partnerId}`;
        this.window._dl.page_inter = "X clicked";
        this.window._dl.action_subject = "minor_interaction:x";
        this.window._dl.page_details = this.window._dl.page_name + ":main:" + this.window._dl.module + ":" + "index" + ":" + this.window._dl.action_subject;
        delete this.window._dl.loaded_modules;
        //delete this.window._dl.action_subject;
        delete this.window._dl.area;
        delete this.window._dl.card_type;
        delete this.window._dl.marketing_banner;
        delete this.window._dl.marketing_modules;
        delete this.window._dl.module;
        delete this.window._dl.navigation_click;
        delete this.window._dl.partnerBadge;
        delete this.window._dl.product_identifier;
        delete this.window._dl.view;
       } else {
        this.window._dl.page_inter = "CANCEL";
        this.window._dl.action_subject = "minor_interaction:cancel";
        this.window._dl.page_name = `exit speedbump ${partnerId}`;
      }
      //PCR013 - End
      this.triggerMinorInteractionSCCall();
    }

  /**
   * Custom page view for HRT/modal overlays.
   * Dispatches SPA_PageView with per-event page_name, test_id, layout, area, module, view,
   * site_section1, site_events, page_details and marketing module signals. Does NOT use
   * `pageLoadFired` suppression so it can fire on each modal load.
   * Required spec: GNADT-8071 (Sign-On HRT Modals).
   */
  public triggerCustomPageView(eventObject: any = {}) {
    this.window._dl.cust_error = "";
    this.window._dl.action_type = eventObject.action_type || "page view";
    if (eventObject.page_name) {
      this.window._dl.page_name = eventObject.page_name;
    }
    if (eventObject.test_id) {
      this.window._dl.test_id = eventObject.test_id;
    }
    this.window._dl.area = eventObject.area || "";
    this.window._dl.module = eventObject.module || this.window._dl.page_name;
    this.window._dl.view = eventObject.view || "index";
    this.window._dl.site_section1 = eventObject.site_section1 || "";
    this.window._dl.action_subject = "";
    this.window._dl.page_inter = "";
    this.window._dl.navigation_click = "";
    this.window._dl.loaded_modules = "";
    this.window._dl.marketing_banner = "";
    this.window._dl.product_identifier = "";
    this.window._dl.card_type = "";
    this.CommonVariables();
    if (this.window?.dataLayer?.dmarLoadedList) {
      this.window._dl.site_events = eventObject.site_events || "event7,event90";
      this.window._dl.marketing_modules = this.window.dataLayer.dmarLoadedList;
    } else {
      this.window._dl.site_events = eventObject.site_events || "event7";
      this.window._dl.marketing_modules = "";
    }
    this.window._dl.page_details = eventObject.page_details || this.window._dl.page_name;
    this.triggerMajorInteractionSCCall(null);
  }

  public triggerDmarAdInteraction(eventObject:any = {}){
  // this.populateCommonVariables();\
  this.window._dl.cust_error = "";
  this.window._dl.action_type = "event";
  this.window._dl.view = eventObject.view;
  this.window._dl.module = "sign_on";
  this.window._dl.marketing_banner = "PRIMARY_SIGN_ON";
  this.window._dl.site_section1 = this.window._dl.page_name;
  this.window._dl.area  = "PRIMARY_SIGN_ON";
  this.window._dl.page_details = this.window._dl.page_name;
  this.CommonVariables();
  this.window._dl.site_events = "event91";
  this.window._dl.loaded_modules = this.populateList1();
  this.window._dl.action_subject = "minor_interaction:" +"ad_interaction";
  this.window._dl.marketing_modules = this.window.dataLayer.dmarLoadedList;
  if(eventObject.action === "CTALinkClick" || eventObject.action === "signonDisclosureLinkClick"){
    this.window._dl.site_section1 = this.window._dl.page_name;
    this.window._dl.area  = eventObject.adUnit.replace(/^.*\/([^/]+)$/,'$1');
    this.window._dl.action_subject = "minor_interaction:ad_interaction";
    this.window._dl.site_events = "event91";
    this.window._dl.page_inter =  `${eventObject.ctaText} clicked`;
    this.window._dl.marketing_modules = this.window.dataLayer.dmarLoadedList;
    this.window._dl.page_details = this.window._dl.page_name + ":" + this.window._dl.area + ":" + this.window._dl.module + ":" + "index" + ":" + this.window._dl.action_subject;
    this.window._dl.loaded_modules = this.populateList1();
    this.window._dl.marketing_banner = eventObject.adUnit.replace(/^.*\/([^/]+)$/,'$1');
  }
    this.triggerMinorInteractionSCCall();
  }
  private triggerMajorInteractionSCCall(elementRef: any){
    var TMSEvent = new CustomEvent("SPA_PageView");
    document.querySelector('body').dispatchEvent(TMSEvent);
    this.clearVariables();
  }

  private triggerMinorInteractionSCCall(){
    var TMSEvent = new CustomEvent("pageInteraction");
    document.querySelector('body').dispatchEvent(TMSEvent);
    this.clearVariables();
  }

  private getQueryStringVariable(variable: any): string {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split("=");
          if (pair[0] == variable) {
                return pair[1];
          }
    }
}

private screenOrientation(){
  var size: any;
  var orientation: any;
      size = "XL";
      if (screen.width < 481)
        size = "XS";
      else if (screen.width < 769)
        size = "S";
      else if (screen.width < 1014)
        size = "M";
      else if (screen.width < 1200)
        size = "L";

      if (screen.width > screen.height)
        orientation = "landscape";
      else
        orientation = "portrait";
      return size + "|" + orientation;
}

private populateView(elementRef: any){
  var view: any;
  try {
    if(elementRef && !elementRef.getAttribute("data-view")){
      while ((elementRef = elementRef.parentElement) && !elementRef.getAttribute("data-view"));
    }
    if (elementRef && elementRef.getAttribute("data-view")) {
      view = elementRef.getAttribute("data-view");
    }
  } catch {
    view = "";
  }
  return view;
}

private populateList1(){
  var areas = (document).querySelectorAll('[data-area]');
    var tempList = [];
    try {
      for (var i = 1; i < areas.length; i++) {
        var modules = areas[i].querySelectorAll('[data-module]');
        for (var j = 0; j < modules.length; j++) {
          tempList.push(areas[i].getAttribute('data-area') + ">" + modules[j].getAttribute('data-module'));
        }
      }
    } catch {
      tempList = []
    }
    return tempList;
}

private populateData(elementRef, attr: string){
  var data: any;
  try {
    if(elementRef && !elementRef.getAttribute(`data-${attr}`)){
      while ((elementRef = elementRef.parentElement) && !elementRef.getAttribute(`data-${attr}`));
    }
    if (elementRef && elementRef.getAttribute(`data-${attr}`)) {
      data = elementRef.getAttribute(`data-${attr}`);
    }
  } catch {
    data = "";
  }
  return data;
}

private populateformId(elementRef: any){
  var formId: any;
  try {
    if (elementRef.querySelector("[data-form-id]")){
      formId = elementRef.querySelector("[data-form-id]").getAttribute("data-form-id");
    }
    else{
    while ((elementRef = elementRef.parentElement) && !elementRef.getAttribute("data-form-id"));
    if (elementRef && elementRef.getAttribute("data-form-id"))
      formId = elementRef.getAttribute("data-form-id");
    }
  } catch {
    formId = "";
  }
  return formId;
}

private populateInputName(elementRef: any){
  var inputName: any;
  if(typeof elementRef !== "string" && elementRef !== undefined)   {
    inputName = elementRef.getAttribute("formcontrolname");
  }
  try {
    if(!inputName || (inputName && inputName.length === 0)) {
      inputName = elementRef.getAttribute("id");
    }
  } catch {
    inputName = "";
  }
  return inputName;
}

private populateModule(elementRef: any){
  var module: any;
  try {
    if (elementRef && !elementRef.getAttribute("data-module")) {
      while ((elementRef = elementRef.parentElement) && !elementRef.getAttribute("data-module"));
    }
    if (elementRef && elementRef.getAttribute("data-module")) {
      module = elementRef.getAttribute("data-module");
    }
  } catch {
    module = "";
  }
  return module;
}

private populateArea(elementRef: any){
  var area: any
  try {
    if (elementRef && !elementRef.getAttribute("data-area")) {
      while ((elementRef = elementRef.parentElement) && !elementRef.getAttribute("data-area"));
    }
    if (elementRef && elementRef.getAttribute("data-area"))
      area = elementRef.getAttribute("data-area");
  } catch {
    area = "";
  }
  return area;
}

private populateScName(elementRef: any){
  let scName: any;
  // find the element that has data-sc-name
  try {
    if(!elementRef.getAttribute("data-sc-name")){
      while ((elementRef = elementRef.parentElement) && !elementRef.getAttribute("data-sc-name"));
    }
    if(elementRef) {
      scName = elementRef.getAttribute("data-sc-name");
    }
  } catch {
    scName = "";
  }
  return scName;
}

public triggerCustomError(eventObject: any) {
  this.window._dl.action_type = "event";
  if (eventObject?.page_name) {
    this.window._dl.page_name = eventObject.page_name;
  }
  if (eventObject?.test_id) {
    this.window._dl.test_id = eventObject.test_id;
  }
  this.window._dl.cust_error = this._svcService.sanitizeErrorText(eventObject?.cust_error ?? "");
  this.window._dl.site_events = eventObject.site_events || "event20";
  this.window._dl.page_details = eventObject.page_details || this.window._dl.page_details;
  this.window._dl.area = eventObject.area || "main";
  this.window._dl.module = eventObject.module || this.window._dl.page_name;
  this.window._dl.view = eventObject.view || "index";
  // Clear properties to prevent triggering additional events
  this.window._dl.action_subject = "";
  this.window._dl.page_inter = "";
  this.window._dl.navigation_click = "";
  this.window._dl.loaded_modules = "";
  this.window._dl.marketing_modules = "";
  this.window._dl.marketing_banner = "";
  this.window._dl.site_section1 = eventObject.site_section1 || "";
  this.window._dl.product_identifier = "";
  this.CommonVariables();
  this.triggerMinorInteractionSCCall();
}

private getPreviousPageName(): string {
  return sessionStorage.getItem('previousPageName');
}

private setPreviousPageName(pageName) {
  sessionStorage.setItem('previousPageName',pageName);
}

private getDetailedPageName(): string {
  return this.detailedPageName;
}

private setDetailedPageName(detailedPageName) {
  this.detailedPageName = detailedPageName;
}
}
